export default __webpack_public_path__ + "static/media/bgs.6c3ceb42.jpg";